import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import './App.css';
import { AuthProvider } from './AuthContext';
import AuthContext from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import Login from "./components/Login";
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import Dashboard from './pages/Dashboard';
import Billing from "./pages/Billing";
import Product from "./pages/Product";
import Addproduct from "./pages/Addproduct";
import Customer from './pages/Customer';
import Addcustomer from './pages/Addcustomer';
import Customerdetails from './pages/Customerdetails';
import GstProduct from './pages/GstProduct';
import Gstbilling from './pages/Gstbilling';
import Settings from './pages/Settings';
import Companysettings from './pages/Companysettings';
import Employee from './pages/Employee';
import Addemployee from './pages/Addemployee';
import Vendor from './pages/Vendor';
import Addvendor from './pages/Addvendor';
import Vendordetails from './pages/Vendordetails';
import Vendorcontactdetails from './pages/Vendorcontactdetails';
import Vendorcontact from './pages/Vendorcontact';
import User from './pages/User';
import Adduser from './pages/Adduser';
import Userdetails from './pages/Userdetails';
import Lead from './pages/Lead';
import Addlead from './pages/Addlead';
import Leaddetails from './pages/Leaddetails';
import Country from './pages/Country';
import State from './pages/State';
import City from './pages/City';
import Department from './pages/Department';
import Userrole from './pages/Userrole';
import Servicetype from './pages/Servicetype';
import Leadqueue from './pages/Leadqueue';
import Usertype from './pages/Usertype';

function AppContent() {
  const { isAuthenticated } = React.useContext(AuthContext);
  const location = useLocation();

  // Check if the current path is "/login"
  const isLoginPage = location.pathname === '/login';

  // Define protected routes as an array of objects to map over
  const protectedRoutes = [

    { path: '/dashboard', element: <Dashboard /> },
    { path: '/billing', element: <Billing /> },
    { path: '/product', element: <Product /> },
    { path: '/customer', element: <Customer /> },
    { path: '/add-customer', element: <Addcustomer /> },
    { path: '/customer-details/:id', element: <Customerdetails /> },
    { path: '/gstproduct', element: <GstProduct /> },
    { path: '/gstbilling', element: <Gstbilling /> },
    { path: '/settings', element: <Settings /> },
    { path: '/company-settings', element: <Companysettings /> },
    { path: '/employee', element: <Employee /> },
    { path: '/add-employee', element: <Addemployee /> },
    { path: '/vendor', element: <Vendor /> },
    { path: '/add-vendor', element: <Addvendor /> },
    { path: '/vendor-details/:id', element: <Vendordetails /> },
    { path: '/vendor-contact-details/:id', element: <Vendorcontactdetails /> },
    { path: '/vendor-contact', element: <Vendorcontact /> },
    { path: '/user', element: <User /> },
    { path: '/add-user', element: <Adduser /> },
    { path: '/user-details/:id', element: <Userdetails /> },
    { path: '/lead', element: <Lead /> },
    { path: '/add-lead', element: <Addlead /> },
    { path: '/lead-details/:id', element: <Leaddetails /> },
    { path: '/country', element: <Country /> },
    { path: '/state', element: <State /> },
    { path: '/city', element: <City /> },
    { path: '/department', element: <Department /> },
    { path: '/user-role', element: <Userrole /> },
    { path: '/service-type', element: <Servicetype /> },
    { path: '/lead-queue', element: <Leadqueue /> },
    { path: '/user-type', element: <Usertype /> }

  ];
  return (
    <div className="App">
      {!isLoginPage ? (
        <div className="main-wrapper">
          {isAuthenticated && <Header />}
          {isAuthenticated && <Sidebar />}
          <div>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
                }
              />

              {/* Protected Routes */}
              {protectedRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={<ProtectedRoute>{route.element}</ProtectedRoute>}
                />
              ))}
            </Routes>
          </div>
        </div>
      ) : (
        // Render only the login page without the wrapper and main layout
        <Routes>
          <Route path="/login" element={<Login />} />
        </Routes>
      )}
    </div>
  );
}

const App = () => (
  <AuthProvider>
    <Router>
      <AppContent />
    </Router>
  </AuthProvider>
);

export default App;
